import React, { useContext, useState } from "react";
import Logo from "../../assets/WhatsApp Image 2025-12-17 at 3.56.49 PM.jpeg";
import { useLocation, useNavigate } from "react-router-dom";
import {
  validateForm,
  validateField,
  validationSchema,
} from "../../schemas/loginValidation";
import { SendOtp } from "../../services/auth/SendOtp";
import { DContext } from "../../context/Datacontext";
import { IoEyeOutline } from "react-icons/io5";
import { FaRegEyeSlash } from "react-icons/fa";
import PrivacyPolicyModal from "./PrivacyPolicyModal";
import { GoogleOAuth } from "./GoogleOAuth";
import Loading from "../../components/Loading";


export const Register = () => {
  const { BeURL, currentUser, Mandatory, loading, setLoading } = useContext(DContext)
  const navigate = useNavigate();

  const location = useLocation()

  const state = location.state || {};

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [open, setOpen] = useState(false)

  const [form, setForm] = useState({
    fullname: "",
    email: "",
    contact: "",
    password: "",
    confirmPassword: "",
    terms: false,
  });

  const [errors, setErrors] = useState({});


  const handleChange = (name, value) => {
    const updatedForm = {
      ...form,
      [name]: value,
    };

    setForm(updatedForm);

    // Validate changed field
    const fieldError = validateField(
      name,
      value,
      updatedForm,
      validationSchema.register,
      "register"
    );

    let newErrors = {
      ...errors,
      [name]: fieldError,
    };

    //Special case: if password changes, revalidate confirmPassword
    if (name === "password" && form.confirmPassword) {
      const confirmError = validateField(
        "confirmPassword",
        form.confirmPassword,
        updatedForm,
        validationSchema.register,
        "register"
      );

      newErrors.confirmPassword = confirmError;
    }

    setErrors(newErrors);
  };

  let role = "user"

  if (currentUser) {
    if (currentUser.role === "superadmin") {
      role = "admin"
    }
    else if (currentUser.role === "admin") {
      role = "instructor"
    }
    else {
      role = "user"
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validateForm(form, validationSchema.register);
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      try {
        setLoading(true)
        const res = await SendOtp({
          BeURL,
          email: form.email,
          purpose: "signup",
        });

        if (res?.success) {
          navigate("/verify", {
            state: { form, role, state },
          });
        } else {
          alert(res?.message);
        }
      } catch (error) {
        console.log("Error in create your account", error);
        alert("Unable to create your account. Please try again later.");
      }
      finally {
        setLoading(false);
      }
    }
  };

  return (
    <div className="flex items-center justify-center ">
      <div className="w-full max-w-md p-6 space-y-4">
        <div className="flex flex-col items-center">
          <img src={Logo} alt="logo" className="mb-6 h-auto w-32" />
        </div>
        <h2 className="text-2xl font-semibold mb-2">Start Learning with SAN LMS</h2>
        <p>Create your account to access industry focused courses, hands on projects, and career ready skills.</p>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="text-sm text-gray-600">Full Name {Mandatory()}</label>
            <input
              placeholder="john doe"
              value={form.fullname}
              onChange={(e) => handleChange("fullname", e.target.value)}
              className={`w-full border rounded-md px-3 py-2 mt-1
                ${errors.fullname ? "border-red-500" : "border-gray-300"}
                focus:outline-none focus:ring-2 focus:ring-primary-500`}
            />
            {errors.fullname && <p className="text-xs text-red-500 mt-1">{errors.fullname}</p>}
          </div>

          <div className="mb-4">
            <label className="text-sm text-gray-600">Email {Mandatory()}</label>
            <input
              placeholder="example@gmail.com"
              value={form.email}
              onChange={(e) => handleChange("email", e.target.value)}
              className={`w-full border rounded-md px-3 py-2 mt-1
                ${errors.email ? "border-red-500" : "border-gray-300"}
                focus:outline-none focus:ring-2 focus:ring-primary-500`}
            />
            {errors.email && <p className="text-xs text-red-500 mt-1">{errors.email}</p>}
          </div>

          <div className="mb-4">
            <label className="text-sm text-gray-600">Contact {Mandatory()}</label>
            <input
              placeholder="+91 1234567890"
              value={form.contact}
              onChange={(e) => handleChange("contact", e.target.value)}
              className={`w-full border rounded-md px-3 py-2 mt-1
                ${errors.contact ? "border-red-500" : "border-gray-300"}
                focus:outline-none focus:ring-2 focus:ring-primary-500`}
            />
            {errors.contact && <p className="text-xs text-red-500 mt-1">{errors.contact}</p>}
          </div>

          <div className="mb-4 relative">
            <label className="text-sm text-gray-600">Password {Mandatory()}</label>
            <input
              type={showPassword ? "text" : "password"}
              placeholder="........"
              value={form.password}
              onChange={(e) => handleChange("password", e.target.value)}
              className={`placeholder:text-gray-400 placeholder:text-4xl w-full border rounded-md px-3 py-2 mt-1
                ${errors.password ? "border-red-500" : "border-gray-300"}
                focus:outline-none focus:ring-2 focus:ring-primary-500`}
            />
            <span
              onClick={() => setShowPassword((s) => !s)}
              className="absolute right-3 top-10 cursor-pointer text-gray-500"
            >
              {showPassword ? (
                <IoEyeOutline />
              ) : (
                <FaRegEyeSlash />
              )}
            </span>
            {errors.password && <p className="text-xs text-red-500 mt-1">{errors.password}</p>}
          </div>

          <div className="mb-4 relative">
            <label className="text-sm text-gray-600">Confirm Password {Mandatory()}</label>
            <input
              type={showConfirm ? "text" : "password"}
              placeholder="........"
              value={form.confirmPassword}
              onChange={(e) => handleChange("confirmPassword", e.target.value)}
              className={` placeholder:text-gray-400 placeholder:text-4xl w-full border rounded-md px-3 py-2 mt-1
                ${errors.confirmPassword ? "border-red-500" : "border-gray-300"}
                focus:outline-none focus:ring-2 focus:ring-primary-500`}
            />
            <span
              onClick={() => setShowConfirm((s) => !s)}
              className="absolute right-3 top-10 cursor-pointer text-gray-500"
            >
              {showConfirm ? (
                <IoEyeOutline />
              ) : (
                <FaRegEyeSlash />
              )}
            </span>
            {errors.confirmPassword && <p className="text-xs text-red-500 mt-1">{errors.confirmPassword}</p>}
          </div>

          <div className="flex items-center gap-2 mb-4">
            <input
              type="checkbox"
              checked={form.terms}
              onChange={(e) => handleChange("terms", e.target.checked)}
            />
            <span className="text-sm text-gray-600">By signing up, you agree to our <span className="text-primary-600" onClick={() => setOpen("privacy")}>Terms & Privacy Policy</span></span>
          </div>
          {errors.terms && <p className="text-xs text-red-500 mb-4">{errors.terms}</p>}

          <button
            type="submit"
            disabled={loading}
            className="w-full flex justify-center bg-primary-600  text-white py-3 rounded-md hover:bg-primary-700 transition"
          >
            {loading ? <Loading size={30} className="text-white" /> : "Create Account"}
          </button>
        </form>
        <p className="text-sm text-gray-500 mb-6">  Already have an account?{" "} <span className="text-primary-600 cursor-pointer font-medium" onClick={() => navigate("/login")}> Log in </span> </p>
        <div className="w-full flex items-center justify-center mb-4">
          <GoogleOAuth BeURL={BeURL}/>
        </div>
      </div>
      {open && <PrivacyPolicyModal isOpen={open} onClose={() => setOpen(false)} />}
    </div>
  );
};
